module.exports = __webpack_public_path__ + "static/media/young-man-with-laptop-sitting-floor_23-2147577277.be2f33f7.jpg";